/* tslint:disable */
/* eslint-disable */

import { ReaderInlineDataFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type consultAnExpert_user = {
    readonly userRelationships: ReadonlyArray<{
        readonly userDataB: ReadonlyArray<{
            readonly displayName?: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "consultAnExpert_user";
};
export type consultAnExpert_user$data = consultAnExpert_user;
export type consultAnExpert_user$key = {
    readonly " $data"?: consultAnExpert_user$data;
    readonly " $fragmentRefs": FragmentRefs<"consultAnExpert_user">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "consultAnExpert_user"
};
(node as any).hash = '8c4eed9e43aec0c5754618668a7b863d';
export default node;
